export type BeneficiaryValue = {
  beneficiary: 'self' | 'other';
  name: string;
  phone: string;
  email: string;
  relation: string;
};

export function emptyBeneficiary(): BeneficiaryValue {
  return { beneficiary: 'self', name: '', phone: '', email: '', relation: '' };
}

export function beneficiaryPayload(value: BeneficiaryValue) {
  if (value.beneficiary === 'self') {
    return { beneficiary: 'self' as const };
  }
  return {
    beneficiary: 'other' as const,
    beneficiaryName: value.name.trim(),
    beneficiaryContact: value.phone.trim() || null,
    beneficiaryEmail: value.email.trim() || null,
    beneficiaryRelation: value.relation.trim() || null,
  };
}

export function isBeneficiaryValid(value: BeneficiaryValue) {
  return value.beneficiary === 'self' || value.name.trim().length >= 2;
}

